<template>
     <div class="flex w-full" style="height: 100%" :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
        <vs-button class="w-full" style="height: 100% !important"  :color="this.params.column.colDef.color || 'primary'" :type="this.params.column.colDef.buttonType || 'border'" icon-pack="feather" 
          :icon="this.params.column.colDef.icon" @click="callOnClickEvent">{{this.params.column.colDef.fixValue  || this.params.valueFormatted || this.params.value || 'NA'}}</vs-button>
    </div>
</template>

<script>

export default {
  methods: {
    callOnClickEvent () {
      this.$parent.$parent.$parent.cellRenderData = this.params
      this.$parent.$parent.$parent.cellRenderAction = true
    }
  }
}
</script>
